<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
    <template #EDIT="{ params, visible }">
      <Form :model="params" :label-position="'left'" :label-width="90">
        <FormItem label="代理名称">
          <Input v-model="params.agent_name" :disabled="true"></Input>
        </FormItem>
        <FormItem label="代理国家">
          <Input v-model="params.agent_country" :disabled="true"></Input>
        </FormItem>
        <FormItem label="VNLIN城市">
          <Input v-model="params.city_code + '（' + params.city_id + '）'" :disabled="true"></Input>
        </FormItem>
        <FormItem label="代理省份">
          <Input v-model="params.agent_province"></Input>
        </FormItem>
        <FormItem label="代理城市">
          <Input v-model="params.agent_city"></Input>
        </FormItem>
        <FormItem label="代理邮编">
          <Input v-model="params.zipcode"></Input>
        </FormItem>
      </Form>
    </template>
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import XLSX from "xlsx";
import {
  batchUploadCity,
  getAgentCityMapping,
  getCityMappingConfig,
  removeCityMapping,
  updateCityMapping
} from "@/api/system/zaji";

export default {
  name: 'AgentCityMapping',
  components: {
    cTable,
  },
  async mounted() {
    const res = await getCityMappingConfig()
    console.clear()
    this.header.searchs.forEach(item => {
      if (typeof res.data.payload[item.key] !== 'undefined') {
        item.options = res.data.payload[item.key]
      }
    })
  },
  data() {
    return {
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
          show: false,
        },
        {
          name: '代理名称',
          key: 'agent_name',
          align: 'center',
          width: 160,
          fixed: 'left',
        },
        {
          name: '映射国家',
          key: 'agent_country',
          align: 'center',
          width: 140,
          fixed: 'left',
        },
        {
          name: 'VNLIN城市ID',
          key: 'city_id',
          align: 'center',
          width: 140,
        },
        {
          name: 'VNLIN城市名称',
          key: 'city_code',
          align: 'center',
        },
        {
          name: '代理省份',
          key: 'agent_province',
          align: 'center',
          width: 220,
        },
        {
          name: '代理城市',
          key: 'agent_city',
          align: 'center',
        },
        {
          name: '代理邮编',
          key: 'zipcode',
          align: 'center',
          width: 120,
        },
        {
          type: 'btns',
          width: 120,
          align: 'right',
          fixed: 'right',
          list: [
            {
              name: '更新',
              type: 'update',
              fnName: 'updateFunc',
              bind: {
                type: 'primary'
              }
            },
            {
              name: '删除',
              type: 'delete',
              fnName: 'deleteFunc',
              bind: {
                type: 'error'
              }
            }
          ],
          methods: {
            updateFunc({row}) {
              this.getModal("operation").open(row, function () {
                  this.setTitle(this.$t("operation"));
                }
              );
            },
            deleteFunc({row}) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("confirm") + this.$t("delete"),
                content: `是否删除代理 ${row.agent_name} 的在国家 ${row.agent_country} 的城市 ${row.city_code} 映射关系?`,
                onOk: () => {
                  removeCityMapping(row.id).then(res => {
                    this.$Message.success({
                      content: this.$t("delete") + this.$t("success"),
                      duration: 2,
                      onClose: () => {
                        this.getList();
                      }
                    })
                  })
                },
              });
            }
          }
        }
      ],
      modals: {
        operation: {
          contentSlot: "EDIT",
          config: {
            modalBind: {
              width: "480px",
            },
          },
          methods: {
            ok: ({row} ) => {
              this.$refs["table"].getModal("operation").openLoading();
              updateCityMapping(row).then(res => {
                this.$refs["table"].getModal("operation").closeLoading();
                if (res.data.code) {
                  this.$Message.error(res.msg)
                } else {
                  this.$Message.success({
                    content: '数据更新成功',
                    duration: 2,
                    onClose: () => {
                      this.$refs["table"].getModal("operation").close();
                      this.getList();
                    }
                  })
                }
              })
            }
          }
        },
        upload: {
          methods: {
            ok() {
              window.open('/excel/agentCityMapping.xlsx');
            }
          },
          footer: {
            cancel: {
              isShow: true
            },
            ok: {
              name: this.$t("download_tem")
            }
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false
            },
            rowBind: {
              gutter: 16
            },
            title: this.$t("upload") + this.$t("files")
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx"
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let table = this.$refs["table"];
                  // 使用 xlsx 读取 file 为 JSON 对象
                  const reader = new FileReader();
                  reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: "array" });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const json = XLSX.utils.sheet_to_json(worksheet);
                    this.$refs["table"].getModal("upload").openLoading()
                    batchUploadCity(json).then(res => {
                      this.$refs["table"].getModal("upload").closeLoading()
                      if (res.data.code) {
                        // 发生错误
                        this.$Message.error(res.data.msg)
                      } else {
                        this.$Message.success({
                          content: '数据更新成功',
                          duration: 2,
                          onClose: () => {
                            this.$refs["table"].getModal("upload").close();
                            this.$refs["table"].getList();
                          }
                        })
                      }
                    })
                  };
                  reader.readAsArrayBuffer(file);

                  return false;
                }
              }
            }
          ]
        }
      },
      header: {
        show: true,
        searchs: [
          {
            key: 'countryCode',
            placeholder() {
              return "请选择国家";
            },
            component: "Select",
            options: [],
          },
          {
            key: 'agentName',
            placeholder() {
              return "请选择代理";
            },
            component: "Select",
            options: [],
          },
          {
            key: 'keywords',
            placeholder() {
              return '请输入关键字'
            },
            bind: {
              type: 'textarea',
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("updateFile"),
              type: "upload",
              fnName: "uploadExcel",
              bind: {
                type: "warning",
                style: "margin-left:10px"
              }
            }
          ],
          methods: {
            uploadExcel: () => {
              this.$refs['table'].getModal('upload').open()
            }
          }
        }
      },
      methods: {
        list: getAgentCityMapping
      },
    }
  }
}
</script>

<style>

</style>
